
(function () {
  if (window.__earnerSubscriptionCheckboxInitialized) return;
  window.__earnerSubscriptionCheckboxInitialized = true;

  var checkoutButtonSelectors = [
    '.card-btn[name="checkout"]',
    '.checkout-credix',
    '.checkout-credix-account',
    '.eth-checkout-btn',
    '#pay-gmo',
    '#pay-manual-bank-transfer-drawer',
    '#pay-manual-bank-transfer',
    '#pay-web3-wallet',
  ];

  function getCheckoutButtons() {
    return document.querySelectorAll(checkoutButtonSelectors.join(', '));
  }

  function getCheckbox() {
    return document.getElementById('earner-subscription-agreement-checkbox');
  }

  function updateButtons(checked) {
    var buttons = getCheckoutButtons();
    buttons.forEach(function (button) {
      if (checked) {
        button.removeAttribute('disabled');
      } else {
        button.setAttribute('disabled', 'disabled');
      }
    });
  }

  function initCheckbox() {
    var checkbox = getCheckbox();
    if (!checkbox) return;

  
    if (checkbox.dataset.listenerSet !== 'true') {
      checkbox.dataset.listenerSet = 'true';
      checkbox.addEventListener('change', function () {
        updateButtons(checkbox.checked);
      });
    }
  }


  initCheckbox();

  document.addEventListener('dispatch:cart-drawer:refresh', function () {
    setTimeout(initCheckbox, 300);
  });

  document.addEventListener('submit', function (e) {
    var cartForm = e.target.closest('#cart-drawer-form, #cart-form');
    var checkbox = getCheckbox();
    if (cartForm && checkbox && !checkbox.checked) {
      e.preventDefault();
      if (typeof showToast === 'function') {
        showToast(window.__cartCheckboxErrorMessage || '同意が必要です', 'error');
      } else {
        alert(window.__cartCheckboxErrorMessage || '同意が必要です');
      }
      return false;
    }
  });

  var cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawer) {
    var observer = new MutationObserver(function (mutations) {
      var shouldInit = false;
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          shouldInit = true;
        }
      });
      if (shouldInit) {
        setTimeout(initCheckbox, 300);
      }
    });
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

    var cartPage = document.getElementById('cart');
  if (cartPage) {
    var cartPageObserver = new MutationObserver(function (mutations) {
      var shouldInit = false;
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          shouldInit = true;
        }
      });
      if (shouldInit) {
        setTimeout(initCheckbox, 300);
      }
    });
    cartPageObserver.observe(cartPage, { childList: true, subtree: true });
  }


  setInterval(function () {
    var checkbox = getCheckbox();
    if (checkbox && !checkbox.checked) {
      var buttons = getCheckoutButtons();
      buttons.forEach(function (button) {
        if (!button.hasAttribute('disabled')) {
          button.setAttribute('disabled', 'disabled');
        }
      });
    }
  }, 500);
})();